import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode.react';
import { postData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { Card, FormField, TextInput, Button, StatusBadge, Chip } from '../UI';
import { tokens } from '../../theme/tokens';

export default function MFAEnrollment() {
  const [uri, setUri] = useState('');
  const [secret, setSecret] = useState('');
  const [code, setCode] = useState('');
  const [status, setStatus] = useState('idle');

  useEffect(() => {
    postData(Endpoints.MFA_ENROL, new FormData())
      .then((res) => res.json())
      .then((res) => {
        setUri(res.uri || '');
        setSecret(res.secret || '');
      });
  }, []);

  const verify = (e) => {
    if (e) e.preventDefault();
    const fd = new FormData();
    fd.append('code', code);
    postData(Endpoints.MFA_VERIFY, fd)
      .then((res) => res.json())
      .then((res) => setStatus(res.ok ? 'enabled' : 'failed'))
      .catch(() => setStatus('failed'));
  };

  if (status === 'enabled') {
    return (
      <PageLayout title="Two-factor authentication">
        <Card style={{ maxWidth: 560 }}>
          <StatusBadge tone="success">Enabled</StatusBadge>
          <h3
            style={{
              margin: '16px 0 6px',
              fontSize: tokens.typography.size.xl,
              fontWeight: 700,
              color: tokens.colors.heading,
            }}
          >
            MFA is on
          </h3>
          <p style={{ margin: 0, color: tokens.colors.muted, lineHeight: 1.5 }}>
            Your account is protected. Your next login will ask for a 6-digit code.
          </p>
        </Card>
      </PageLayout>
    );
  }

  return (
    <PageLayout title="Two-factor authentication">
      <Card style={{ maxWidth: 620 }}>
        <h3
          style={{
            margin: '0 0 8px',
            fontSize: tokens.typography.size.xl,
            fontWeight: 700,
            color: tokens.colors.heading,
          }}
        >
          Set up an authenticator
        </h3>
        <p style={{ margin: '0 0 20px', color: tokens.colors.muted, lineHeight: 1.5 }}>
          Scan this QR code with Google Authenticator, Authy, 1Password, or any TOTP app.
        </p>

        <div
          style={{
            display: 'inline-flex',
            padding: 16,
            background: tokens.colors.surface,
            border: `1px solid ${tokens.colors.border}`,
            borderRadius: tokens.radii.md,
            boxShadow: tokens.shadows.xs,
          }}
        >
          {uri ? <QRCode value={uri} size={200} /> : 'Loading…'}
        </div>

        <p style={{ margin: '20px 0 8px', color: tokens.colors.muted }}>
          Or enter this secret manually:
        </p>
        <Chip style={{ fontFamily: tokens.typography.fonts.mono }}>{secret || '—'}</Chip>

        <form onSubmit={verify} style={{ marginTop: 24, maxWidth: 320 }}>
          <FormField
            label="Enter the current 6-digit code"
            htmlFor="enrolCode"
            error={status === 'failed' ? 'Invalid code, try again.' : ''}
          >
            <TextInput
              id="enrolCode"
              type="text"
              inputMode="numeric"
              maxLength={6}
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                if (status === 'failed') setStatus('idle');
              }}
              placeholder="123456"
              style={{ letterSpacing: '0.4em', fontWeight: 700 }}
            />
          </FormField>
          <Button type="submit">Verify &amp; enable</Button>
        </form>
      </Card>
    </PageLayout>
  );
}
